import { render, staticRenderFns } from "./DeparturesPageCampoGrande.vue?vue&type=template&id=55c97bc4&scoped=true&"
import script from "./DeparturesPageCampoGrande.vue?vue&type=script&lang=js&"
export * from "./DeparturesPageCampoGrande.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPageCampoGrande.vue?vue&type=style&index=0&id=55c97bc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c97bc4",
  null
  
)

export default component.exports